import { render, staticRenderFns } from "./header2.vue?vue&type=template&id=2feabdb2&scoped=true&"
import script from "./header2.vue?vue&type=script&lang=js&"
export * from "./header2.vue?vue&type=script&lang=js&"
import style0 from "./header2.vue?vue&type=style&index=0&lang=css&"
import style1 from "./header2.vue?vue&type=style&index=1&id=2feabdb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feabdb2",
  null
  
)

export default component.exports